import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=0bb18c5e&scoped=true&"
import script from "./Billing.vue?vue&type=script&lang=js&"
export * from "./Billing.vue?vue&type=script&lang=js&"
import style0 from "./Billing.vue?vue&type=style&index=0&id=0bb18c5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb18c5e",
  null
  
)

export default component.exports